/**
 * Каталог проектных документов МСБИ.
 * Markdown загружается напрямую из ../разработка/мсби/ (см. vite.config.js).
 */

const rawModules = import.meta.glob('../../../разработка/мсби/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
})

function fileIdFromPath(path) {
  const name = path.split(/[/\\]/).pop() || ''
  return name.replace(/\.md$/i, '')
}

/** @type {Map<string, string>} */
const contentById = new Map(
  Object.entries(rawModules).map(([path, content]) => [fileIdFromPath(path), content])
)

export const MSBI_DOC_GROUPS = [
  {
    id: 'meta',
    label: 'Обзор',
    docs: [
      {
        id: 'README',
        title: 'Оглавление пакета',
        subtitle: 'Состав и порядок утверждения',
        badge: 'overview',
      },
      {
        id: '00-README-oficialnye-s-sayta',
        title: 'Расхождения с проектом',
        subtitle: 'Официальные документы vs черновики',
        badge: 'note',
      },
    ],
  },
  {
    id: 'official',
    label: 'Официальные (с сайта)',
    docs: [
      {
        id: '00-ustav-suma-2026',
        title: 'Устав СШБИ / SUMA',
        subtitle: 'Редакция 2026',
        badge: 'official',
      },
      {
        id: '00-attestatsionnye-trebovaniya-suma-2025',
        title: 'Аттестационные требования',
        subtitle: 'Конгресс 2025',
        badge: 'official',
      },
    ],
  },
  {
    id: 'normative',
    label: 'Проектные нормативные',
    docs: [
      {
        id: '01-polozhenie-ob-attestacii',
        title: '01 · Положение об аттестации',
        subtitle: 'Kyu, dan, комиссии, экзаменаторы',
        badge: 'draft',
      },
      {
        id: '02-polozhenie-ob-instructorah-i-ekzamenatorah',
        title: '02 · Инструкторы и экзаменаторы',
        subtitle: 'Inst, Exam, курсы',
        badge: 'draft',
      },
      {
        id: '03-edinye-trebovaniya-sroki-vozrast',
        title: '03 · Единые требования',
        subtitle: 'Возраст, сроки, стаж',
        badge: 'draft',
      },
      {
        id: '04-reglament-attestacionnyh-komissij',
        title: '04 · Регламент комиссий',
        subtitle: 'Состав, протоколы, кворум',
        badge: 'draft',
      },
      {
        id: '05-formy-i-blanki',
        title: '05 · Формы и бланки',
        subtitle: 'AT, CERT, EX, SG — 18 форм',
        badge: 'draft',
      },
      {
        id: '06-stilevoe-prilozhenie-obrazec',
        title: '06 · Стилевое приложение',
        subtitle: 'Образец Annex (каратэ)',
        badge: 'draft',
      },
      {
        id: '07-polozhenie-o-zvaniyah-shogo',
        title: '07 · Звания (Shogo)',
        subtitle: 'Renshi, Kyoshi, Hanshi',
        badge: 'draft',
      },
    ],
  },
  {
    id: 'reference',
    label: 'Справочные и методички',
    docs: [
      {
        id: '08-pamyatka-tri-treka',
        title: '08 · Памятка: три трека',
        subtitle: 'Ранг · лицензия · звание',
        badge: 'guide',
      },
      {
        id: '09-sravnitelnaya-tablica-vozrast-1-dan',
        title: '09 · Сравнение: 1 dan',
        subtitle: 'Мировые организации',
        badge: 'reference',
      },
      {
        id: '10-rekomenduemaya-svodnaya-tablica-dan',
        title: '10 · Сводная таблица dan',
        subtitle: 'Комиссии, TIG, экзаменаторы',
        badge: 'reference',
      },
      {
        id: '11-sistema-ekzamenatorskih-litsenzij',
        title: '11 · Лицензии экзаменаторов',
        subtitle: 'KE / DE / ME / SE — grading examiner licences',
        badge: 'reference',
      },
    ],
  },
]

export const MSBI_DOCS = MSBI_DOC_GROUPS.flatMap((group) =>
  group.docs.map((doc) => ({ ...doc, groupId: group.id, groupLabel: group.label }))
)

export const MSBI_DOC_IDS = new Set(MSBI_DOCS.map((d) => d.id))

export const MSBI_DEFAULT_DOC_ID = 'README'

export function getMsbiDocContent(docId) {
  return contentById.get(docId) ?? ''
}

export function getMsbiDocMeta(docId) {
  return MSBI_DOCS.find((d) => d.id === docId) ?? null
}

export function extractMsbiHeadings(markdown) {
  const headings = []
  const lines = markdown.split('\n')
  for (const line of lines) {
    const match = /^(#{2,3})\s+(.+)$/.exec(line.trim())
    if (!match) continue
    const level = match[1].length
    const text = match[2].replace(/\*\*/g, '').replace(/`/g, '').trim()
    const slug = text
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s-]/gu, '')
      .replace(/\s+/g, '-')
    headings.push({ level, text, slug })
  }
  return headings
}

export const MSBI_BADGE_LABELS = {
  overview: 'Оглавление',
  note: 'Пояснение',
  official: 'Утверждено',
  draft: 'Проект',
  guide: 'Методичка',
  reference: 'Справочник',
}
